import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import DrawAnimation from "./DrawAnimation";
import { ShowInfo } from "./ShowInfo";
import Avatar from '../Avatar';

const Main = () => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const url = "https://www.planspiel-bw.de/planspiel?getjson=1";
    fetch(url)
      .then(res => res.json())
      .then(data => {
        setData(data);
        setLoading(false);
      });
  }, []);

  const dialog = data.dialogInfo;
  const user = data.username ?? " ";
  console.log(data.backgroundImage);
	const firstname = user.slice(0,user.indexOf(" "));
	var message = `Hallo ${firstname}! Ich bin dein Assistent. Ich helfe dir bei Entscheidungen!`

  const onClickDecision = () => navigate("/decision");
  const onClickArchive = () => navigate("/archive");
  const onClickHelp = () => navigate("/help");

  return (
    <main className="min-h-screen flex flex-col items-center justify-center bg-white px-4 text-center">
      <Avatar message={message}/>

<motion.div
        initial={{ y: 40, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.5, duration: 0.8 }}
        className="max-w-xl"
      >
        <h1 className="text-3xl font-bold mb-4">Herzlich willkommen zum JUGEND GRÜNDET Planspiel {user}!</h1>
        <p className="text-gray-600 mb-6">
          Die aktuelle Wettbewerbsphase läuft bis 05. Mai 2025 um 12:00 Uhr mittags.
        </p>
      </motion.div>
      <motion.div
        className="w-64 h-64 mb-8"
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <div className="logo-animation">
          <span className="w-100 text-xl font-semibold text-gray-500">
            <DrawAnimation backgroundImageUrl={data.backgroundImage}/>
          </span>
          <ShowInfo data={dialog} />
          <button onClick={onClickDecision} className="button button--solid berichte">Berichte und Entscheidungen</button>
          <button onClick={onClickArchive} className="button button--solid archiv">Archiv</button>
          <button onClick={onClickHelp} className="button button--solid help">Hilfe</button>
        </div>
      </motion.div>

     
    </main>
  );
};

export default Main;
